import React from "react";
import { HeaderHome } from "./headerHome";
import { MainHome } from "./mainHome";

export const HomePage = () => {
  return (
    <>
      <HeaderHome />
      <MainHome />
    </>
  );
};
